import gql from 'graphql-tag'

const Task = gql`
  query Task($id: ID!) {
    task(id: $id) {
      id
      description
      priority
      taskType {
        id
        name
        description
      }
      status
      createdAt
      claimId
      emailMessage {
        id
        createdAt
        type
        from
        to
        subject
        content
        htmlPart
        claimState
      }
      claim {
        id
        passengerTicketId
        airlineAmicableAnswer
        airlinePreLitigationAnswer
        formalNoticeSent
        emailMessagesConnection {
          edges {
            cursor
            node {
              id
              createdAt
              type
              from
              to
              subject
              content
              htmlPart
              claimState
              documentsConnection {
                edges {
                  node {
                    id
                    cid
                    documentUrl
                    attachmentFileName
                    attachmentContentType
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`

export { Task }



// WEBPACK FOOTER //
// ./src/queries/Task.js